import React from 'react'
import Header from '../../components/Header in Page/_Header'
import NewHeader from '../../components/New Header/NewHeader'
import './_newFaiDaTe.scss'
import { useNavigate } from 'react-router-dom';
import ArrowForwardIos from '@mui/icons-material/ArrowForwardIos';
import voltura from '../../assets/img/voltura.svg'
import spostamento from '../../assets/img/spostamento.svg'
import disalimentazione from '../../assets/img/disalimentazione.svg'
import diminuzione from '../../assets/img/diminuzione.svg'
import aumento from '../../assets/img/aumento.svg'
import cambio from '../../assets/img/cambio.svg'
import pagamento from '../../assets/img/pagamenti.svg'
import stime from '../../assets/img/stime.svg'
import tagliaSoglia from '../../assets/img/tagliaesoglia.svg'

function NewFaiDaTe() {
    const navigate = useNavigate()
    const items = [
        {
            titolo: 'Taglia e Soglia',
            // descrizione: 'Qui puoi impostare taglia e soglia.',
            icon: <img src={tagliaSoglia} alt="pagamento"/>,
            url: '/enrica/fai-da-te/soglia-taglia'
        },
        {
            titolo: "Le tue stime",
            // descrizione: 'Qui puoi visualizzare o modificare le tue stime.',
            icon: <img src={stime} alt="cambio"/>,
            url: '/enrica/fai-da-te/stime'
        },
        {
            titolo: 'Voltura',
            // descrizione: 'Con la voltura puoi cambiare intestazione al tuo contratto senza interrompere la fornitura di energia elettrica.',
            icon: <img src={voltura} alt="voltura"/>,
            url: '/enrica/fai-da-te/voltura'
        },
        {
            titolo: "Spostamento contatore",
            // descrizione: 'Puoi spostare il tuo contatore nella stessa particella catastale o in un’altra particella in cui non è presente.',
            icon: <img src={spostamento} alt="spostamento"/>,
            url: '/enrica/fai-da-te/spostamento'
        },
        {
            titolo: 'Disalimentazione',
            // descrizione: 'Qui puoi richiedere di disalimentare (interrompere l’erogazione di energia) il tuo contatore e di chiudere il tuo contratto.',
            icon: <img src={disalimentazione} alt="disalimentazione"/>,
            url: '/enrica/fai-da-te/chiudere'
        },
        {
            titolo: 'Aumento potenza',
            // descrizione: 'Se la potenza del tuo contatore non è sufficiente per le tue esigenze puoi scegliere di aumentarla in questa sezione.',
            icon: <img src={aumento} alt="aumento"/>,
            url: '/enrica/fai-da-te/aumento-potenza'
        },
        {
            titolo: 'Diminuire potenza',
            // descrizione: 'Se non hai più bisogno di una potenza elevata del contatore puoi scegliere di diminuirla in questa sezione.',
            icon: <img src={diminuzione} alt="diminuzione"/>,
            url: '/enrica/fai-da-te/diminuzione-potenza'
        },
        {
            titolo: "Cambio destinazione d'uso",
            // descrizione: 'Qui puoi cambiare la tipologia della tua utenza scegliendo tra Domestico Residente, Domestico Non Residente o Altri usi.',
            icon: <img src={cambio} alt="cambio"/>,
            url: '/enrica/fai-da-te/cambio'
        },
        {
            titolo: 'Cambio metodo di pagamento',
            // descrizione: 'Qui puoi richiedere l’addebito delle tue fatture su conto corrente o, viceversa, scegliere di pagare con le ricariche.',
            icon: <img src={pagamento} alt="pagamento"/>,
            url: '/enrica/cambio-metodo'
        }
    ]
    const handleView = async(url) => {
        navigate(url)
     }
  return (
    <div className='faiDaTe'>
        <div className="faiDaTe-top">
            <NewHeader logo='white' padding='no' iconsColor='white' />
        </div>
        <div className="faiDaTe-bottom">
            <Header
              title="Fai da te"
              description={`Questa è l'area Fai da te dove potrai controllare le tue utenze. In pochi semplici passi guidati, ti aiuteremo a gestire la tua energia.`}
                icon="faiDaTe"
            />
            <div className="moreInfo">
                <p onClick={() => navigate('/enrica/fai-da-te/faq')}>Non hai le idee chiare? </p>
                <ArrowForwardIos/>
            </div>
            <div className="items">
                {items.map((item, i) => (
                    <div key={i} className="item" onClick={() => handleView(item.url)}>
                        <div className="icon">
                            {item.icon}
                        </div>
                        <div className="text">
                            <p className="title">{item.titolo}</p>
                            {/* <p className="descrizione">{item.descrizione}</p> */}
                        </div>
                        <div className="arrow">
                            <ArrowForwardIos />
                        </div>
                    </div>
                ))}
                <div className="empty" style={{height: '100px'}}></div>
            </div>
        </div>
    </div>
  )
}

export default NewFaiDaTe